module.exports = __webpack_public_path__ + "static/img/25.e440510.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/25.jpg
// module id = Ytm3
// module chunks = 0